export default "<p>expansion-panel works!</p>\r\n"